import {createModel} from "@rematch/core";
import {RootModel} from "./index";
import request from "../util/request";

export const showOrders: any = createModel<RootModel>()({
  state: {
    info: {},
    request: {
      keywords: "",
      pageNum: 1,
      pageSize: 20,
      payStatus: "",
      showId: "",
    },
    data: {
      total: 0,
      pageNum: 1,
      pageSize: 20,
      list: [],
    },
    shows: [],
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    /**
     * 设置值
     *
     * @param state
     * @param payload
     */
    setData(state, payload) {
      return {...state, ...payload}
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    /**
     * 分页获取订单列表
     */
    async getPage(payload, rootState) {
      let res = await request.post("/host-admin/v1/showOrders/page", rootState.showOrders.request)
      if (res.code === 0) {
        res.data.list.forEach((item: any) => {
          item.key = item.orderNo
        })
        dispatch.showOrders.setData({data: res.data})
      }
      return res
    },

    /**
     * 获取订单详情
     *
     * @param orderNo
     * @param rootState
     */
    async getInfo(orderNo, rootState) {
      let res = await request.get(`/host-admin/v1/showOrders/info/${orderNo}`)
      if (res.code === 0) {
        dispatch.showOrders.setData({info: res.data})
      }
      return res
    },

    /**
     * 订单退款
     *
     * @param orderNo
     * @param rootState
     */
    async refund(orderNo, rootState) {
      let res = await request.post(`/host-admin/v1/showOrders/refund/${orderNo}`, {})
      return res
    },

    /**
     * 获取演出列表
     */
    async getShows(payload, rootState) {
      let res = await request.get("/host-admin/v1/showOrders/shows")
      if (res.code === 0) {
        dispatch.showOrders.setData({shows: res.data})
      }
      return res
    },

    /**
     * 下载演出订单
     *
     * @param payload
     * @param rootState
     */
    async download(payload, rootState) {
      let params = {
        showId: rootState.showOrders.request.showId,
        payStatus: rootState.showOrders.request.payStatus
      }
      await request.download("/host-admin/v1/showOrders/download", params, "showOrders.xlsx")
    },

  }),
}) 